import { useState } from "react";
import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IStepCompetitionConfigSearchParam,
  IStepCompetitionConfigTableReport,
} from "../../../Interfaces/stepInterfaces";
import {
  getCompetitionInstrumentOptions,
  getStepCompetitionConfigTable,
} from "../../../Requests/stepRequests";
import TableUI from "./TableUI";
import DynamicDropdown from "../../../Components/Dropdown/DynamicDropdown";

interface IProps {
  onTableRowClick: (row: IStepCompetitionConfigTableReport) => void;
}

const CompetitionConfigTable = ({ onTableRowClick }: IProps) => {
  const [searchParams, setSearchParams] =
    useState<IStepCompetitionConfigSearchParam>({});

  const onInstrumentChange = (_: string, value: any) => {
    setSearchParams(value ? { instrumentId: value } : {});
  };

  return (
    <div className="flex flex-col justify-start items-start w-full gap-3">
      <div className="w-60">
        <DynamicDropdown
          dropdown={{
            name: "instrumentId",
            placeholder: "نماد",
            extraLabel: true,
          }}
          onChange={onInstrumentChange}
          getData={getCompetitionInstrumentOptions}
          value={searchParams.instrumentId}
        />
      </div>
      <TableTemplate<
        IStepCompetitionConfigSearchParam,
        IStepCompetitionConfigTableReport
      >
        searchParameters={searchParams}
        getDataTable={(searchParam, offset, pageSize, sortingType) =>
          getStepCompetitionConfigTable(searchParam, offset, pageSize, sortingType)
        }
        TableUI={({ reports, onAction }) => (
          <TableUI
            reports={reports}
            onAction={onAction}
            onTableRowClick={onTableRowClick}
          />
        )}
      />
    </div>
  );
};

export default CompetitionConfigTable;
